import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ChakraProvider, Box } from '@chakra-ui/react';
import { chakraUiTheme } from '@everfi/design-system';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

var ChakraUIProvider = function ChakraUIProvider(_ref) {
  var children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? chakraUiTheme : _ref$theme;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      oneRender = _useState2[0],
      setOneRender = _useState2[1];

  useEffect(function () {
    return setOneRender(true);
  }, []);
  var serverSide = typeof window === 'undefined';

  if (serverSide || !oneRender) {
    var cache = createCache({
      key: 'custom'
    });
    return /*#__PURE__*/React.createElement(CacheProvider, {
      value: cache
    }, children);
  }

  return /*#__PURE__*/React.createElement(ChakraProvider, {
    resetCSS: true,
    theme: theme
  }, /*#__PURE__*/React.createElement(Box, null, children));
};

ChakraUIProvider.displayName = "ChakraUIProvider";
ChakraUIProvider.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object
};
export { ChakraUIProvider };